<template>
    <div class="role-select">
        <v-tip
            ref="qqTip"
            clazz="role-select-qq-tip"
            placement="top"
        >
            <span>该角色含有QQ沟通相关权限，选择后将为员工自动分配QQ员工号<br>若员工已有QQ员工号，不会重复分配</span>
        </v-tip>
        <div class="role-select-header">
            <div class="role-select-tips">
                <slot name="tips">
                    {{ tips }}
                </slot>
            </div>
            <link-refresh
                @refresh="roleRefresh"
                class="role-select-header-right"
                link-url="/mng/role#/jumpcreate"
                link-txt="创建角色"
            />
        </div>
        <div
            v-spinner="loading"
            class="role-select-list"
        >
            <v-spinner
                :opacity="0.5"
                :offset-y="150"
                size="large"
            />
            <div
                v-for="item in roleList"
                :key="item.roleId"
                v-tip="`item_${item.roleId}`"
                :class="getRoleClass(item)"
                @click="roleItemClick(item)"
                class="role-select-item"
            >
                <v-tip
                    :ref="`item_${item.roleId}`"
                    :gap="-10"
                    :disabled="!item.disabled && !item.checkDisabled && !item.unavailable"
                    placement="top"
                >
                    <span v-html="item.tip" />
                </v-tip>
                <div
                    @click.stop
                    class="role-select-item-checkbox"
                >
                    <v-checkbox
                        v-model="item.checked"
                        :disabled="item.disabled || item.checkDisabled || item.unavailable"
                    />
                </div>
                <div class="role-select-item-content">
                    <div class="role-select-item-img">
                        <v-icon name="roleMan" />
                    </div>
                    <div
                        v-tip.hover="`itemTitle${item.roleId}`"
                        class="role-select-item-title"
                    >
                        {{ item.roleName }}
                    </div>
                    <v-tip :ref="`itemTitle${item.roleId}`">
                        {{ item.roleName }}
                    </v-tip>
                    <div class="role-select-item-package">
                        <p
                            v-for="(packName, packId) in item.packages"
                            :key="packId"
                        >
                            {{ packName }}
                        </p>
                    </div>
                </div>
                <div class="role-select-item-privileges">
                    <span @click.stop="privClick(item)">权限({{ item.priCount }})</span>
                    <div
                        v-if="item.hasQQPrivilege && accountCompleteTag"
                        class="role-select-item-qq-icon"
                    >
                        <v-icon
                            v-tip:qqTip.delay
                            name="qq"
                            class="role-permission-qq-icon"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div
            v-show="showQuota"
            class="role-select-quota"
        >
            <p
                v-for="pItem in showQuotaList"
                :key="pItem.id"
            >
                {{ pItem.name }} 可用配额：{{ pItem.available }}
            </p>
        </div>

        <priv-list-panel
            v-if="firstShowPrivPanel"
            v-model="showPrivPanel"
            :role-data="currRole"
            :back-txt="backTxt"
        />
    </div>
</template>
<script>
import { Icon } from 'vhtml-ui';
import Gateway from 'src/utils/Gateway';
import LinkRefresh from 'src/components/link-refresh';
import PrivListPanel from 'src/components/priv-list-panel';
import { isInAccountComplete } from 'src/cgi/getWhiteList';
import { getUserCombosBatch } from 'src/cgi/getUserCombos';

const sprites = require.context('./assets/icons', true, /[^.]+\.svg$/);
Icon.addSprites(sprites);

export default {
    components: {
        LinkRefresh,
        PrivListPanel,
    },

    props: {
        extraReqParams: {
            type: Object,
            default() {
                return {};
            },
        },

        selectedIdArr: {
            type: Array,
            default() {
                return [];
            },
        },

        backTxt: {
            type: String,
            default: '返回角色',
        },

        tips: {
            type: String,
            default: '选择后当前员工将消耗角色所对应的套餐配额',
        },

        // 处理单个角色数据，把角色数据的disabled设置成true标志要禁用这个角色
        itemDataFunction: {
            type: Function,
            default: null,
        },

        // 套餐配额不足角色是否要置灰
        setPackageDisable: {
            type: Boolean,
            default: true,
        },

        kfext: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            firstShowPrivPanel: false,
            showPrivPanel: false,
            roleList: [],
            quotaList: [],
            quotaAddMap: {},
            selectedPackIdSet: new Set(),
            checkedPackIdSet: new Set(),
            currRole: {},
            loading: true,
            hasSelectedKefu: false,
            accountCompleteTag: false,
            showQuota: false,
        };
    },

    computed: {
        checkedItemArr() {
            return this.roleList.filter(item => item.checked);
        },

        checkedPackagesMap() {
            const checkedMap = {};

            this.checkedItemArr.forEach((item) => {
                const { packages } = item || {};
                Object.keys(packages).forEach((pkg) => {
                    checkedMap[pkg] = 1;
                });
            });

            return checkedMap;
        },

        showQuotaList() {
            return this.quotaList.map((item) => {
                const { id, name, available } = item || {};
                const showAvailable = available + (this.quotaAddMap[id] || 0) - (this.checkedPackagesMap[id] || 0);

                return {
                    name,
                    available: Math.max(showAvailable, 0),
                };
            });
        },
    },

    watch: {
        checkedItemArr() {
            this.checkChange();
        },
    },

    created() {
        this.roleDataReq();
        // this.quotaReq();

        // 判断是否有完整的新账号功能
        isInAccountComplete().then((val) => {
            this.accountCompleteTag = val;
        });
    },

    methods: {
        roleDataReq() {
            this.loading = true;
            this.$ajax
                .read('/mng/role/roleList', { ...this.extraReqParams })
                .then((res) => {
                    const list = (res && res.list) || [];

                    this.roleList = this.formatRoleList(list);

                    this.quotaReq();

                    this.emitChange();
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        quotaReq() {
            if (this.accountCompleteTag) {
                Gateway.post('/v1/combo/getFullCombos').then((data) => {
                    const { combos } = data || {};
                    const list = [];
                    Object.keys(combos).forEach((k) => {
                        const combo = combos[k];
                        const { id, name, remain, total } = combo || {};

                        list.push({
                            id,
                            name,
                            available: remain,
                            total,
                        });
                    });

                    this.quotaList = list;
                    // this.disableRole(this.roleList, list);
                    this.handleKfextQuota();
                });
            } else {
                this.$ajax.read('/mng/role/PackageQuota').then((res) => {
                    const list = (res && res.list) || [];

                    this.quotaList = list;
                    // this.disableRole(this.roleList, list);
                    this.handleKfextQuota();
                });
            }
        },

        // 获取工号套餐配额情况
        handleKfextQuota() {
            this.quotaAddMap = {};
            if (this.kfext) {
                getUserCombosBatch({
                    kfexts: [Number(this.kfext)],
                }).then((data) => {
                    const { UserCombos } = data || {};
                    const { combos } = (UserCombos && UserCombos[this.kfext]) || {};

                    if (Array.isArray(combos)) {
                        combos.forEach((pkg) => {
                            const { id } = pkg || {};
                            this.quotaAddMap[id] = 1;
                        });
                    }

                    this.disableRole(this.roleList, this.quotaList);
                });
            } else {
                this.disableRole(this.roleList, this.quotaList);
            }
        },

        // 套餐配额不足时置灰
        // 已选中角色的套餐配额和剩余套餐配额计算
        // 客服协同联合售卖互斥置灰
        // 敏感操作权限置灰
        // 非QQ沟通权限置灰
        // 其他置灰情况抛个函数出去

        disableRole(roleList, packageList) {
            // const selectedRole = roleList.filter(role => role.checked);
            const isCreate = this.extraReqParams.opt === 'create';

            // 敏感权限管理，不管是创建还是编辑，逻辑一致
            roleList.forEach((role) => {
                if (role.exceedLimit) {
                    this.$set(role, 'disabled', true);
                    this.$set(role, 'tip', '该角色超出了你的权限范围<br/>不可给员工赋予该角色');
                }
            });
            // 创建和编辑逻辑分开
            if (isCreate) {
                if (this.setPackageDisable) {
                    // 创建员工的时候，存在配额为0的disabled和提示
                    this.disableRoleNoQuota(packageList, roleList);
                }
            } else {
                // 编辑的时候，判断配额为0的情况
                // 先把已选角色包含的套餐存起来
                // this.quotaAddMap = {};
                // selectedRole.forEach((role) => {
                //     Object.keys(role.packages).forEach((pkg) => {
                //         this.quotaAddMap[pkg] = 1;
                //     });
                // });

                this.disableRoleNoQuota(packageList, roleList);
                // this.disableRoleExclusivePackage('disabled');

                // 套餐互斥
                // 如果闯将的时候选择了一个kefu套餐，即使取消勾选，xietong套餐的角色依旧全部为disabled
                // 如果闯将的时候选择了一个xietong套餐，即使取消勾选，kefu套餐的角色依旧全部为disabled
                // if (selectedRole.length > 0) {
                //     // 当前员工为【在线客服】套餐<br/>不可使用【企业QQ 2.0】套餐的角色
                //     // 当前员工为【企业QQ 2.0】套餐<br/>不可使用其他套餐的角色
                //     roleList.forEach((role) => {
                //         if (this.hasSelectedKefu) {
                //             if (role.$_type === 'xietong') {
                //                 this.$set(role, 'disabled', true);
                //                 this.$set(
                //                     role,
                //                     'tip',
                //                     '当前员工为【在线客服】套餐<br/>不可使用【企业QQ 2.0】套餐的角色',
                //                 );
                //             }
                //         } else if (role.$_type === 'kefu') {
                //             this.$set(role, 'disabled', true);
                //             this.$set(role, 'tip', '当前员工为【企业QQ 2.0】套餐<br/>不可使用其他套餐的角色');
                //         }
                //     });
                // }
            }

            this.showQuota = true;
        },

        checkDisableRole() {
            // this.disableRoleExclusivePackage('checkDisabled');
            // const selectedRole = this.roleList.filter(role => role.checked);

            // // 套餐互斥
            // // 如果选择了一个kefu套餐，则xietong套餐的角色全部为disabled
            // // 如果选择了一个xietong套餐，则kefu套餐的角色全部为disabled
            // if (selectedRole.length > 0) {
            //     // 如果是选择的包含客服套餐
            //     let selectedKefu = false;
            //     for (let i = 0; i < selectedRole.length; i++) {
            //         if (selectedRole[i].$_type === 'kefu') {
            //             selectedKefu = true;
            //             break;
            //         }
            //     }

            //     // 当前员工为【在线客服】套餐<br/>不可使用【企业QQ 2.0】套餐的角色
            //     // 当前员工为【企业QQ 2.0】套餐<br/>不可使用其他套餐的角色
            //     this.roleList.forEach((role) => {
            //         if (selectedKefu) {
            //             if (role.$_type === 'xietong') {
            //                 this.$set(role, 'checkDisabled', true);
            //                 this.$set(role, 'tip', '当前员工为【在线客服】套餐<br/>不可使用【企业QQ 2.0】套餐的角色');
            //             }
            //         } else if (role.$_type === 'kefu') {
            //             this.$set(role, 'checkDisabled', true);
            //             this.$set(role, 'tip', '当前员工为【企业QQ 2.0】套餐<br/>不可使用其他套餐的角色');
            //         }
            //     });
            // } else {
            //     this.roleList.forEach((role) => {
            //         this.$set(role, 'checkDisabled', false);
            //     });
            // }
        },

        disableRoleNoQuota(packageList, roleList) {
            const packageMap = new Map();
            packageList.forEach((pkg) => {
                packageMap.set(String(pkg.id), pkg);
            });

            roleList.forEach((role) => {
                if (role.packages && !role.disabled) {
                    Object.keys(role.packages).forEach((pkgKey) => {
                        const pkg = String(pkgKey);
                        if (packageMap.has(pkg) && packageMap.get(pkg).available === 0 && !this.quotaAddMap[pkg]) {
                            this.$set(role, 'disabled', true);
                            !role.newAdmin && this.$set(role, 'tip', '无法为当前员工赋予该角色<br/>因为该角色对应的套餐可用配额为0');
                        }
                    });
                }
            });
        },

        // 套餐互斥
        // xietong与kefu互斥，独立套餐不与任何套餐互斥
        disableRoleExclusivePackage(disItemType) {
            let disRoleType;
            let disTips;

            const disOpts = {
                kefu: {
                    disType: 'xietong',
                    tips: '当前员工为【在线客服】套餐<br/>不可使用【企业QQ 2.0】套餐的角色',
                },
                xietong: {
                    disType: 'kefu',
                    tips: '当前员工为【企业QQ 2.0】套餐<br/>不可使用其他套餐的角色',
                },
            };

            this.checkedItemArr.forEach((item) => {
                if (disOpts[item.$_type]) {
                    disRoleType = disOpts[item.$_type].disType;
                    disTips = disOpts[item.$_type].tips;
                }
            });

            this.roleList.forEach((role) => {
                if (disRoleType && role.$_type === disRoleType) {
                    if (!role.disabled) {
                        this.$set(role, disItemType, true);
                        !role.newAdmin && this.$set(
                            role,
                            'tip',
                            disTips,
                        );
                    }
                } else if (disItemType === 'checkDisabled') {
                    this.$set(role, disItemType, false);
                }
            });
        },

        // 获取当前套餐中包含的协同套餐列表
        getFilterXtList(obj) {
            if (window.QD_ADMIN_COMMON && window.QD_ADMIN_COMMON.filterXtPackage) {
                return window.QD_ADMIN_COMMON.filterXtPackage(obj);
            }
            return [];
        },

        roleItemClick(item) {
            if (item.disabled || item.checkDisabled || item.unavailable) {
                return;
            }
            if (item.newAdmin) item.newChecked = !item.checked;
            item.checked = !item.checked;
            this.emitChange();
        },

        privClick(item) {
            this.currRole = item;
            this.showPrivPanel = true;
            this.firstShowPrivPanel = true;
        },

        getCheckedPackId() {},

        checkChange() {
            this.checkDisableRole(this.roleList);
            this.emitChange();
        },

        emitChange() {
            this.$emit('change', this.checkedItemArr);
        },

        roleRefresh() {
            this.roleDataReq();
        },

        getRoleClass(item) {
            return {
                'role-select-item-active': item.checked,
                'role-select-item-disabled': item.disabled || item.checkDisabled || item.unavailable,
            };
        },

        getRoleType(role) {
            if (window.QD_ADMIN_COMMON && window.QD_ADMIN_COMMON.getRoleType) {
                const { packages } = role || {};
                return window.QD_ADMIN_COMMON.getRoleType(packages);
            }
            return '';
            // const { isAdmin, packages } = role || {};
            // const filterXtList = this.getFilterXtList(role.packages);
            // const checkXietong = filterXtList.length > 0;

            // // 超级管理员角色是否具有多套餐
            // const isComboAdmin = isAdmin && checkXietong && Object.keys(packages).length > filterXtList.length;

            // let type = 'kefu';

            // if (checkXietong && (parseInt(isAdmin, 10) !== 1 || !isComboAdmin)) {
            //     type = 'xietong';
            // }

            // return type;
        },

        formatRoleList(list) {
            let formatList = [];

            if (Array.isArray(list)) {
                formatList = list.map((item) => {
                    let formatItem = item || {};
                    const type = this.getRoleType(item);
                    formatItem.$_type = this.getRoleType(item);

                    if (parseInt(item.selected, 10) === 1 || this.selectedIdArr.includes(item.roleId)) {
                        formatItem.checked = true;

                        if (type === 'kefu') {
                            this.hasSelectedKefu = true;
                        }
                    } else {
                        formatItem.checked = false;
                    }

                    if (this.itemDataFunction) {
                        formatItem = this.itemDataFunction(item);
                    }

                    if (item.unavailable) {
                        formatItem.tip = '无法为当前员工赋予该角色 ';
                    }

                    return formatItem;
                });
            }

            formatList.sort((item) => {
                if (item.checked) {
                    return -1;
                }

                return 0;
            });

            return formatList;
        },
    },
};
</script>

<style lang="less">
@import './index.less';
</style>
